// Inside testSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentState: false,
};

const testSlice = createSlice({
  name: "test",
  initialState,
  reducers: {
    setTestState: (state, action) => {
      console.log(action.payload, "action.payload");
      state.currentState = action.payload;
    },
  },
});

export const { setTestState } = testSlice.actions; // Export action here

export default testSlice.reducer; // Export reducer as default
